"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarButtonIcon = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const ToolbarButtonIcon = (0, _styled.default)("div")`
    box-sizing: border-box;
    display: flex;
    flex-shrink: 0;
    flex-flow: column;
    line-height: 0;
    font-size: 0;
    user-select: none;
    max-height: 100%;
    align-items: center;

    * > {
        max-height: 20px;
        min-height: 18px;
        height: auto;
    }
`;
exports.ToolbarButtonIcon = ToolbarButtonIcon;
//# sourceMappingURL=ToolbarButtonIcon.js.map